import React from 'react';
import SubmitForm from './SubmitForm';

const App = () => {
  return (
    <div>
      <center><h1>Submit Form</h1></center>
      <SubmitForm />
    </div>
  );
};

export default App;
